import { FC } from 'react';
import { faIdCardSolid, faSearch } from '~/assets';
import { currencyParser } from '~/modules';
import { formatShortDate } from '~/utils';
import StatusIndicator from '../StatusIndicator';
import {
  AccountText,
  Balance,
  Card,
  IconCard,
  IconSearch,
  Row,
  SearchIconBox,
  Text,
} from './styles';

type Props = {
  bankNumber?: string;
  branchNumber?: string;
  accountNumber?: string;
  accountDigit?: string;
  accountStatus?: string;
  createdAt?: string;
  globalBalance?: number;
  onPress?(): void;
};

const CustomerAccountRow: FC<Props> = ({
  bankNumber = '',
  branchNumber = '',
  accountNumber = '',
  accountDigit = '',
  accountStatus = '',
  createdAt = '',
  globalBalance = 0,
  onPress,
}) => {
  return (
    <Card>
      <Row>
        <IconCard icon={faIdCardSolid} />
        <Text>{bankNumber}</Text>
      </Row>
      <Row>
        <Text>{branchNumber}</Text>
      </Row>
      <Row>
        <AccountText>{accountNumber}</AccountText>
      </Row>
      <Row>
        <Text>{accountDigit}</Text>
      </Row>
      <Row>
        <StatusIndicator status={accountStatus as any} />
      </Row>
      <Row>
        <Text>{formatShortDate(new Date(createdAt))}</Text>
      </Row>
      <Row>
        <Balance>{currencyParser(globalBalance || '')}</Balance>
      </Row>
      {onPress && (
        <Row>
          <SearchIconBox onClick={onPress}>
            <IconSearch icon={faSearch} />
          </SearchIconBox>
        </Row>
      )}
    </Card>
  );
};

export default CustomerAccountRow;
